(function () {
  if (window.TrackProPdpSectionsInitialized) return;
  window.TrackProPdpSectionsInitialized = true;

  function updateCarouselButtons(track, prev, next) {
    if (!track || !prev || !next) return;
    const maxScroll = track.scrollWidth - track.clientWidth - 2;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= maxScroll;
  }

  function bindVideoPlayButtons(scope) {
    const bindVideoState = (media, video) => {
      if (video.dataset.tpv3StateBound === 'true') return;

      const syncState = () => {
        if (video.paused || video.ended) {
          media.classList.remove('is-playing');
          video.controls = false;
        } else {
          media.classList.add('is-playing');
          video.controls = true;
        }
      };

      video.addEventListener('play', syncState);
      video.addEventListener('pause', syncState);
      video.addEventListener('ended', syncState);
      video.dataset.tpv3StateBound = 'true';
    };

    const playVideo = (media, video) => {
      bindVideoState(media, video);
      media.classList.add('has-started');
      const source = video.querySelector('source');
      const sourceUrl = source ? source.getAttribute('src') : video.getAttribute('src');
      if (sourceUrl && video.dataset.tpv3LoadedSource !== sourceUrl) {
        video.load();
        video.dataset.tpv3LoadedSource = sourceUrl;
      }
      video.controls = true;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise
          .then(() => {
            media.classList.add('is-playing');
          })
          .catch(() => {
            media.classList.remove('is-playing');
          });
      } else {
        media.classList.add('is-playing');
      }
    };

    const pauseVideo = (media, video) => {
      video.pause();
      video.controls = false;
      media.classList.remove('is-playing');
    };

    const videoMediaItems = scope.querySelectorAll('[data-tpv3-video-media]');
    videoMediaItems.forEach((media) => {
      if (media.dataset.tpv3AreaToggleBound === 'true') return;
      media.dataset.tpv3AreaToggleBound = 'true';

      const video = media.querySelector('video');
      if (!video) return;
      bindVideoState(media, video);

      media.addEventListener('click', (event) => {
        if (event.target.closest('[data-tpv3-video-play]')) return;
        if (video.paused || video.ended) {
          playVideo(media, video);
        } else {
          pauseVideo(media, video);
        }
      });
    });

    const playButtons = scope.querySelectorAll('[data-tpv3-video-play]');
    playButtons.forEach((button) => {
      if (button.dataset.tpv3Bound === 'true') return;
      button.dataset.tpv3Bound = 'true';

      button.addEventListener('click', () => {
        const media = button.closest('[data-tpv3-video-media]');
        if (!media) return;

        media.classList.add('has-started');
        const video = media.querySelector('video');
        if (video) {
          playVideo(media, video);
          return;
        }

        const iframe = media.querySelector('[data-tpv3-video-embed]');
        if (!iframe) return;

        const currentSrc = iframe.getAttribute('src') || '';
        if (!iframe.dataset.baseSrc) {
          iframe.dataset.baseSrc = currentSrc;
        }

        if (media.classList.contains('is-playing')) return;

        const sourceUrl = iframe.dataset.baseSrc || currentSrc;
        let nextUrl = sourceUrl;
        try {
          const url = new URL(sourceUrl, window.location.origin);
          url.searchParams.set('autoplay', '1');
          url.searchParams.set('playsinline', '1');
          nextUrl = url.toString();
        } catch (error) {
          const separator = sourceUrl.includes('?') ? '&' : '?';
          nextUrl = `${sourceUrl}${separator}autoplay=1&playsinline=1`;
        }

        iframe.setAttribute('src', nextUrl);
        media.classList.add('is-playing');
      });
    });
  }

  function initTestimonials(root) {
    const sections = root.querySelectorAll('[data-tpv3-testimonials]');
    sections.forEach((section) => {
      if (section.dataset.tpv3Ready === 'true') return;
      section.dataset.tpv3Ready = 'true';

      bindVideoPlayButtons(section);

      const track = section.querySelector('[data-tpv3-testimonials-track]');
      const prev = section.querySelector('[data-tpv3-carousel-prev]');
      const next = section.querySelector('[data-tpv3-carousel-next]');
      if (track && prev && next) {
        const scrollByCard = (direction) => {
          const firstCard = track.querySelector('.tpv3-testimonial-card');
          const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : track.clientWidth * 0.8;
          track.scrollBy({ left: direction * (cardWidth + 16), behavior: 'smooth' });
        };

        prev.addEventListener('click', () => scrollByCard(-1));
        next.addEventListener('click', () => scrollByCard(1));

        track.addEventListener('scroll', () => updateCarouselButtons(track, prev, next), { passive: true });
        window.addEventListener('resize', () => updateCarouselButtons(track, prev, next));
        updateCarouselButtons(track, prev, next);
      }
    });
  }

  function initFaq(root) {
    const faqLists = root.querySelectorAll('[data-tpv3-faq]');
    faqLists.forEach((list) => {
      if (list.dataset.tpv3Ready === 'true') return;
      list.dataset.tpv3Ready = 'true';

      const items = Array.from(list.querySelectorAll('[data-tpv3-faq-item]'));
      const animations = new WeakMap();

      const stopAnimation = (item) => {
        const animation = animations.get(item);
        const content = item.querySelector('[data-tpv3-faq-content]');
        if (animation && content) {
          content.removeEventListener('transitionend', animation.onTransitionEnd);
          content.style.transition = '';
          if (animation.frame) {
            window.cancelAnimationFrame(animation.frame);
          }
        }
        animations.delete(item);
      };

      const setItemOpen = (item, shouldOpen, skipAnimation) => {
        const trigger = item.querySelector('[data-tpv3-faq-trigger]');
        const content = item.querySelector('[data-tpv3-faq-content]');
        const inner = content && content.firstElementChild;
        if (!trigger || !content || !inner) return;

        stopAnimation(item);
        content.style.overflow = 'hidden';
        const openHeight = inner.scrollHeight;

        if (skipAnimation) {
          item.classList.toggle('is-open', shouldOpen);
          trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
          content.style.height = shouldOpen ? `${openHeight}px` : '0px';
          return;
        }

        const startHeight = content.getBoundingClientRect().height;
        const endHeight = shouldOpen ? openHeight : 0;

        if (startHeight === endHeight) {
          item.classList.toggle('is-open', shouldOpen);
          trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
          content.style.height = shouldOpen ? `${openHeight}px` : '0px';
          return;
        }

        content.style.transition = 'none';
        content.style.height = `${startHeight}px`;
        content.offsetHeight;

        item.classList.toggle('is-open', shouldOpen);
        trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');

        const onTransitionEnd = (event) => {
          if (event.propertyName !== 'height') return;
          content.style.transition = '';
          content.style.height = item.classList.contains('is-open') ? `${inner.scrollHeight}px` : '0px';
          content.removeEventListener('transitionend', onTransitionEnd);
          animations.delete(item);
        };

        const frame = window.requestAnimationFrame(() => {
          content.style.transition = 'height 320ms cubic-bezier(0.22, 1, 0.36, 1)';
          content.style.height = `${endHeight}px`;
        });

        animations.set(item, { onTransitionEnd, frame });
        content.addEventListener('transitionend', onTransitionEnd);
      };

      const syncItemHeight = (item) => {
        const content = item.querySelector('[data-tpv3-faq-content]');
        const inner = content && content.firstElementChild;
        if (!content || !inner) return;
        stopAnimation(item);
        content.style.height = item.classList.contains('is-open') ? `${inner.scrollHeight}px` : '0px';
      };

      items.forEach((item) => {
        const trigger = item.querySelector('[data-tpv3-faq-trigger]');
        if (!trigger) return;

        setItemOpen(item, item.classList.contains('is-open'), true);

        trigger.addEventListener('click', () => {
          const shouldOpen = !item.classList.contains('is-open');

          if (shouldOpen) {
            items.forEach((other) => {
              if (other !== item) setItemOpen(other, false, false);
            });
          }

          setItemOpen(item, shouldOpen, false);
        });
      });

      window.addEventListener('resize', () => {
        items.forEach(syncItemHeight);
      });
    });
  }

  function initMainProduct(root) {
    const cards = root.querySelectorAll('[data-tpv3-main-product]');
    cards.forEach((card) => {
      if (card.dataset.tpv3MainReady === 'true') return;
      card.dataset.tpv3MainReady = 'true';

      const offerCards = Array.from(card.querySelectorAll('[data-tpv3-offer-card]'));
      if (!offerCards.length) return;

      const variantInput = card.querySelector('[data-tpv3-variant-input]');
      const priceEl = card.querySelector('[data-tpv3-selected-price]');
      const compareEl = card.querySelector('[data-tpv3-selected-compare]');
      const submitBtn = card.querySelector('[data-tpv3-main-submit]');
      const submitText = card.querySelector('[data-tpv3-submit-text]');
      const variantDataNode = card.querySelector('[data-tpv3-variant-json]');
      const productInfo = card.closest('product-info');
      let variants = [];

      if (variantDataNode) {
        try {
          variants = JSON.parse(variantDataNode.textContent || '[]');
        } catch (error) {
          variants = [];
        }
      }

      const setSelected = (selectedCard, updateUrl) => {
        if (!selectedCard) return;

        offerCards.forEach((cardEl) => {
          const isActive = cardEl === selectedCard;
          cardEl.classList.toggle('is-active', isActive);
          cardEl.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        if (variantInput) {
          variantInput.value = selectedCard.dataset.variantId || '';
        }

        if (priceEl && selectedCard.dataset.priceText) {
          priceEl.textContent = selectedCard.dataset.priceText;
        }

        const savingsPercent = Number(selectedCard.dataset.savingsPercent || 0);
        const compareText = selectedCard.dataset.compareText || '';
        if (compareEl) {
          if (savingsPercent > 0 && compareText) {
            compareEl.textContent = compareText;
            compareEl.classList.remove('is-hidden');
          } else {
            compareEl.textContent = '';
            compareEl.classList.add('is-hidden');
          }
        }

        const isAvailable = selectedCard.dataset.available === 'true';
        if (submitBtn) {
          submitBtn.disabled = !isAvailable;
          if (submitText) {
            const addLabel = submitBtn.dataset.labelAdd || submitText.textContent || '';
            const soldLabel = submitBtn.dataset.labelSold || addLabel;
            submitText.textContent = isAvailable ? addLabel : soldLabel;
          }
        }

        const selectedId = selectedCard.dataset.variantId;
        if (updateUrl && selectedId) {
          try {
            const params = new URLSearchParams(window.location.search);
            params.set('variant', selectedId);
            const next = `${window.location.pathname}?${params.toString()}`;
            window.history.replaceState({}, '', next);
          } catch (error) {
            // Ignore URL update issues in restricted environments.
          }
        }

        if (productInfo && selectedId) {
          const variant = variants.find((item) => String(item.id) === String(selectedId));
          if (variant) {
            productInfo.dispatchEvent(
              new CustomEvent('variant:change', {
                bubbles: true,
                detail: {
                  sectionId: productInfo.dataset.section,
                  variant,
                },
              })
            );
          }
        }
      };

      offerCards.forEach((offer) => {
        offer.addEventListener('click', () => {
          if (offer.disabled) return;
          setSelected(offer, true);
        });
      });

      const activeCard =
        offerCards.find((cardEl) => cardEl.classList.contains('is-active') && !cardEl.disabled) ||
        offerCards.find((cardEl) => !cardEl.disabled) ||
        offerCards[0];
      setSelected(activeCard, false);
    });
  }

  function initDescription(root) {
    const descriptions = root.querySelectorAll('[data-tpv3-description]');
    descriptions.forEach((description) => {
      if (description.dataset.tpv3Ready === 'true') return;
      description.dataset.tpv3Ready = 'true';

      const content = description.querySelector('[data-tpv3-description-content]');
      const toggle = description.querySelector('[data-tpv3-description-toggle]');
      const toggleLabel = description.querySelector('[data-tpv3-description-toggle-label]');
      if (!content || !toggle) return;

      const expandLabel = toggle.dataset.labelExpand || toggle.textContent || 'Read more';
      const collapseLabel = toggle.dataset.labelCollapse || 'Show less';

      const updateState = () => {
        description.classList.remove('is-expanded');
        content.style.removeProperty('--tpv3-description-expanded-height');

        const collapsedHeightValue = getComputedStyle(description.closest('.tpv3-section') || description)
          .getPropertyValue('--tpv3-description-collapsed-height')
          .trim();
        const collapsedHeight = Number.parseFloat(collapsedHeightValue) || 260;

        if (content.scrollHeight > collapsedHeight + 16) {
          description.classList.add('is-collapsible');
          toggle.hidden = false;
          if (toggleLabel) toggleLabel.textContent = expandLabel;
        } else {
          description.classList.remove('is-collapsible');
          toggle.hidden = true;
          if (toggleLabel) toggleLabel.textContent = expandLabel;
        }
      };

      toggle.addEventListener('click', () => {
        const isExpanded = description.classList.toggle('is-expanded');
        if (toggleLabel) {
          toggleLabel.textContent = isExpanded ? collapseLabel : expandLabel;
        }
      });

      updateState();
      window.addEventListener('resize', updateState);
    });
  }

  function initReviews(root) {
    const reviewSections = root.querySelectorAll('[data-tpv3-reviews]');
    reviewSections.forEach((section) => {
      if (section.dataset.tpv3ReviewReady === 'true') return;
      section.dataset.tpv3ReviewReady = 'true';

      const cards = Array.from(section.querySelectorAll('[data-tpv3-review-card]'));
      const toggle = section.querySelector('[data-tpv3-reviews-toggle]');
      const toggleLabel = section.querySelector('[data-tpv3-reviews-toggle-label]');
      const initialCount = Number.parseInt(section.dataset.tpv3InitialCount || '4', 10) || 4;
      const moreLabel = section.dataset.tpv3LabelMore || 'Show more';
      const lessLabel = section.dataset.tpv3LabelLess || 'Show less';
      let expanded = false;

      if (toggle && cards.length > initialCount) {
        const applyVisibility = () => {
          cards.forEach((card, index) => {
            card.hidden = !expanded && index >= initialCount;
          });

          if (toggleLabel) {
            toggleLabel.textContent = expanded ? lessLabel : moreLabel;
          }

          toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        };

        applyVisibility();
        toggle.addEventListener('click', () => {
          expanded = !expanded;
          applyVisibility();
        });
      }

      const modal = section.querySelector('[data-tpv3-review-lightbox]');
      const modalTrack = section.querySelector('[data-tpv3-review-lightbox-track]');
      const prevButton = section.querySelector('[data-tpv3-review-lightbox-prev]');
      const nextButton = section.querySelector('[data-tpv3-review-lightbox-next]');
      const triggers = section.querySelectorAll('[data-tpv3-review-image-trigger]');
      const closeButtons = section.querySelectorAll('[data-tpv3-review-lightbox-close]');
      let currentIndex = 0;
      let totalSlides = 0;
      let scrollFrame = null;

      if (!modal || !modalTrack || !triggers.length) return;

      const clampIndex = (index) => {
        if (totalSlides < 1) return 0;
        return Math.max(0, Math.min(index, totalSlides - 1));
      };

      const updateNav = () => {
        if (!prevButton || !nextButton) return;
        const isSingle = totalSlides <= 1;
        prevButton.hidden = isSingle;
        nextButton.hidden = isSingle;
        prevButton.disabled = isSingle || currentIndex <= 0;
        nextButton.disabled = isSingle || currentIndex >= totalSlides - 1;
      };

      const scrollToIndex = (index, behavior = 'smooth') => {
        if (!modalTrack.children.length) return;
        currentIndex = clampIndex(index);
        const targetSlide = modalTrack.children[currentIndex];
        if (!targetSlide) return;
        modalTrack.scrollTo({ left: targetSlide.offsetLeft, behavior });
        updateNav();
      };

      const closeModal = () => {
        if (modal.hidden) return;
        modal.hidden = true;
        modalTrack.innerHTML = '';
        currentIndex = 0;
        totalSlides = 0;
        updateNav();
        document.documentElement.style.removeProperty('overflow');
      };

      const openModal = (trigger) => {
        const card = trigger.closest('[data-tpv3-review-card]');
        const cardTriggers = card ? Array.from(card.querySelectorAll('[data-tpv3-review-image-trigger]')) : [trigger];
        if (!cardTriggers.length) return;

        modalTrack.innerHTML = '';

        cardTriggers.forEach((item) => {
          const src = item.dataset.imageSrc || '';
          if (!src) return;

          const slide = document.createElement('figure');
          slide.className = 'tpv3-review-lightbox__slide';

          const image = document.createElement('img');
          image.className = 'tpv3-review-lightbox__slide-image';
          image.loading = 'lazy';
          image.src = src;
          image.alt = item.dataset.imageAlt || '';

          slide.appendChild(image);
          modalTrack.appendChild(slide);
        });

        totalSlides = modalTrack.children.length;
        if (!totalSlides) return;

        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';

        const startIndex = Math.max(0, cardTriggers.indexOf(trigger));
        window.requestAnimationFrame(() => {
          scrollToIndex(startIndex, 'auto');
        });
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => openModal(trigger));
      });

      closeButtons.forEach((button) => {
        button.addEventListener('click', closeModal);
      });

      updateNav();

      if (prevButton) {
        prevButton.addEventListener('click', () => {
          scrollToIndex(currentIndex - 1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          scrollToIndex(currentIndex + 1);
        });
      }

      modalTrack.addEventListener('scroll', () => {
        if (modal.hidden || !modalTrack.children.length) return;
        if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => {
          scrollFrame = null;
          const currentLeft = modalTrack.scrollLeft;
          let nearestIndex = currentIndex;
          let nearestDistance = Number.POSITIVE_INFINITY;

          Array.from(modalTrack.children).forEach((slide, index) => {
            const distance = Math.abs(slide.offsetLeft - currentLeft);
            if (distance < nearestDistance) {
              nearestDistance = distance;
              nearestIndex = index;
            }
          });

          if (nearestIndex !== currentIndex) {
            currentIndex = nearestIndex;
            updateNav();
          }
        });
      });

      document.addEventListener('keydown', (event) => {
        if (modal.hidden) return;
        if (event.key === 'Escape') {
          closeModal();
          return;
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          scrollToIndex(currentIndex - 1);
          return;
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          scrollToIndex(currentIndex + 1);
        }
      });
    });
  }

  function init(root) {
    bindVideoPlayButtons(root);
    initTestimonials(root);
    initFaq(root);
    initMainProduct(root);
    initDescription(root);
    initReviews(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
